module.exports = __webpack_public_path__ + "img/qualityIndex.2aa74c0d.png";